<template>

	<div
		:class="{'topic-cluster':true,showHidden:showHidden}"
	>

		<div
			v-for="(opt, optionIndex) in info.results" 
			:key="optionIndex"
			:class="{isHidden:isHidden(optionIndex)}"
		>
		<p>{{opt}}</p> <font-awesome-icon icon="eye-slash" :style="{ color: '#3b445b' }" title="Hide from export" class="eyed" v-if="!isHidden(optionIndex)" @click="clickedHide(optionIndex)" />
			<font-awesome-icon icon="eye" :style="{ color: '#3b445b' }" title="Un-hide from export" class="eyed" v-if="isHidden(optionIndex)" @click="clickedHide(optionIndex)" />
			<a :href="googleURL+'&q='+encodeURIComponent(opt)" target="_blank"><font-awesome-icon icon="search" :style="{ color: '#3b445b' }" title="SERP"  /></a>
		</div>

		<p class="only-available" v-if="info.quantity>info.results.length&&info.results.length>0">Sorry the AI was only able to generate {{info.results.length}} results.</p>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import general from '../../utils/general'
export default {
	name: 'TopicCluster',
	components: {  },
	props: {
		data: {
			type: Array,
			default: () => { return []; }
		},
		tab: {
			type: Object,
			default: () => { return {}; }
		},
		subTabId: {
			type: String,
			default:''
		},
		md5Key: {
			type: String
		},
		googleURL: {
			type: String,
			default: ''
		},
		showHidden: {
			type: Boolean
		}
	},
	data() {

		return {
			
			isHidden (k) {

				return this.hiddenKeys.indexOf( k ) >= 0;

			}

		}

	},
	watch: {

	},
	computed: {

		info () {

			let tabId = this.subTabId || this.tab._id;

			const found = this.data.find( f => f.tabId === tabId );

			if ( found && found.results && found.results.length > 0 ) {

				return found;

			}

			return { results: [] }

		},

		hiddenKeys () {

			let tabId = this.subTabId || this.tab._id;

			const found = this.data.find( f => f.tabId === tabId );

			if ( found && found.hidden && found.hidden.length > 0 ) {

				return found.hidden;

			}

			return [];

		},

		isAdmin () {

			return general.isAdmin();

		}

    },
	created() {

		

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		clickedHide ( index ) {

			this.$emit( 'clickedHide', { hide: !this.isHidden(index), index: index } );

		}

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.topic-cluster {

	.only-available {

		font-style: italic;
		color: @formDefaultColour;

	}

	> div {

		margin: 10px 10px 0;

		p {
			display: inline-block;
			padding: 0;
			margin: 0;
		}

		&.isHidden {

			p {
				opacity: 0.5;
			}

		}

		svg {

			opacity:0.7;
			cursor: pointer;

			&:hover, &.selected {

				opacity: 1;

			}

		}

	}

	&:not(.showHidden) {

		.isHidden {

			display: none;

		}

	}

}
@media screen and (min-width: 480px) {
	.topic-cluster {

		

	}
}
@media screen and (min-width: 768px) {
	.topic-cluster {

		

	}
}
@media screen and (min-width: 960px) {

	.topic-cluster {

		

	}

}
</style>